import { useMemo } from 'react';
import { getScorecardColumns, PeriodType } from '../helpers/getScorecardColumns';

interface UseScorecardColumnsParams {
    selectedPeriod: string;
    dateRanges: { startDate: string; endDate: string; fiscalYear?: number }[];
    isAdmin: boolean;
    selectedUnit: 'INPUT_UNIT' | 'DEFAULT_UNIT';
    isOnEditMode: boolean;
    isArchivedTable: boolean;
    currentTimeframe?: string;
    onSuccess?: () => void;
    userRoles: string[];
}

export const useScorecardColumns = ({
    selectedPeriod,
    dateRanges,
    isAdmin,
    selectedUnit,
    isOnEditMode,
    isArchivedTable,
    currentTimeframe,
    onSuccess,
    userRoles,
}: UseScorecardColumnsParams) => useMemo(() => {
    const periodTypeMap: Record<string, PeriodType> = {
        'Monthly': 'Monthly',
        'Quarterly': 'Quarterly',
        'Yearly': 'Yearly'
    };

    const periodType = periodTypeMap[selectedPeriod] || 'Monthly';

    return getScorecardColumns({
        periodType,
        dateRanges,
        isAdmin,
        selectedUnit,
        isOnEditMode,
        isArchivedTable,
        currentTimeframe,
        onSuccess,
        userRoles,
    });
}, [selectedPeriod, dateRanges, isAdmin, selectedUnit, isOnEditMode, isArchivedTable, currentTimeframe, onSuccess, userRoles]);

